var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEyeoffreact = function SvgEyeoffreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M8 4c-1.292 0-2.52.387-3.566.891L3.565 3.09C4.787 2.5 6.317 2 8 2s3.213.501 4.435 1.09l-.869 1.801C10.52 4.387 9.292 4 8 4M2 7.5v.047C2.891 8.285 5.279 10 8 10c.763 0 1.505-.135 2.204-.351.836-.259 1.597-.63 2.236-1.01A12.4 12.4 0 0 0 14 7.548V7.5h2v.073c0 .542-.223 1.094-.679 1.476a14 14 0 0 1-.914.7l.883 1.139-1.58 1.225-1.028-1.325q-.433.221-.915.421l.678 1.965-1.89.653-.699-2.024a9 9 0 0 1-.856.14V14H7v-2.058a10 10 0 0 1-.856-.139l-.699 2.024-1.89-.653.678-1.965q-.495-.205-.94-.433L2.3 12.1.7 10.9l.874-1.165c-.386-.272-.69-.514-.895-.686A1.92 1.92 0 0 1 0 7.573V7.5z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgEyeoffreact;